import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">        
        <a href="https://www.kartex.net" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">KarteX</a>
    </div>`
})
export class AppFooter { }
